module.exports = __webpack_public_path__ + "static/media/faq-accepted-docs.dad1ea11.svg";